import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getPaperGroups({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_PAPER_GROUPS_REQUEST')

        return axios
            .get(`/papers/paper-groups${paginate}${query}`)
            .then(response => {
                commit('GET_PAPER_GROUPS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PAPER_GROUPS_FAILURE')
                handleApiError(error, 'Pobranie grup papierów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createPaperGroup({ commit }, data) {
        return axios
            .post('/papers/paper-groups', data)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Grupa została dodana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie grupy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updatePaperGroup({ commit }, data) {
        const id = data.id,
            payload = {
                name: data.name,
                isVisible: data.isVisible
            }

        return axios
            .patch(`/papers/paper-groups/${id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Grupa papieru została zedytowana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja grupy papieru nie powiodła się.')

                return Promise.reject(error)
            })
    },
    setPaperGroupsFilters({ commit }, filters) {
        commit('SET_PAPER_GROUPS_FILTERS', filters)
    },
    clearPaperGroupsFilters({ commit }) {
        commit('CLEAR_PAPER_GROUPS_FILTERS')
    }
}